import Dropdown from 'src/components/ui/dropdownMenuTable/dropdownMenuTable';
import OptionsIcon from 'src/components/dealer-mgmt/options-icon';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const MenuItem = ({ moveDealerFunction }: { moveDealerFunction: Function }) => {
    return (
        <>
            <li className='menu-items' onClick={() => moveDealerFunction()}>
                <span>Move to another group</span>
            </li>
        </>
    );
};

interface IItem {
    dealerNumber: string;
    dealerName: string;
    status: string;
}

export const TableItem = (props: { data: IItem }) => {
    const { data } = props;
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    function moveDealerFunctionhandler() {
        navigate('/dashboard/systemadmin/dealer-group-maintenance/move', {
            state: {
                dealerIdToMove: data.dealerNumber,
            },
        });
    }
    return (
        <>
            <div className='sl-table-row'>
                <div className='table-row col-1'>
                    <span className='list-label'>Dealer Group</span>
                    <span>{data.dealerNumber}</span>
                </div>
                <div className='table-row col-2'>
                    <span className='list-label'>Dealer Name</span>
                    <span>{data.dealerName}</span>
                </div>

                <div className='table-row col-3'>
                    <span className='list-label'>Status</span>
                    <span>{data.status}</span>
                </div>

                <div className='table-row col-4'>
                    <span className='list-label'></span>
                    <span
                        className='options-icon'
                        data-testid={`table-item-${''}`}
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        <OptionsIcon />
                    </span>
                    <Dropdown
                        dropdown={open}
                        showSelected={false}
                        showSelectedIcon={false}
                        handlerChange={(value: boolean) => {
                            setOpen(value);
                        }}
                    >
                        <MenuItem
                            moveDealerFunction={moveDealerFunctionhandler}
                        />
                    </Dropdown>
                </div>
            </div>
        </>
    );
};

export const Table = (props: any) => {
    const { items } = props;

    return (
        <div className='sl-table'>
            <div className='sl-table-row header-row hidden-in-list'>
                <div className='table-header col-1'>
                    <span className='u-text-truncate'>Dealer Group</span>
                </div>
                <div className='table-header col-2'>
                    <span className='u-text-truncate'>Dealer Name</span>
                </div>
                <div className='table-header col-3'>
                    <span className='u-text-truncate'>Status</span>
                </div>
                <div className='table-header col-4 menu-header'></div>
            </div>
            {items
                .flatMap((group: any) => group.dealers)
                .map((item: IItem) => (
                    <TableItem key={item.dealerNumber} data={item} />
                ))}
        </div>
    );
};
